<template>
  <div class="role-page page-padding-top">
    <top-bar :title="title" class="long" @back="back" @right="readAll"></top-bar>

    <div class="notice-detail">
      <div class="title">{{noticeData.Title}}</div>
      <div class="time">{{noticeData.CreatedAt}}</div>
      <div class="content" v-html="noticeData.Content"></div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  data() {
    return {
      title: '',
      noticeData: {}
    }
  },
  mounted() {
    let data = sessionStorage.getItem('noticeDetail')
    if (data) {
      this.noticeData = JSON.parse(data)
      this.title = this.noticeData.Title
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    readAll() {

    }
  }
}
</script>